import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import {
    appUrl,
    form,
    leadTextId,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { toastError } from '../../views/components/error';
import { clearCustomFields, loadCustomFields } from '../actions/consultActions';
import { checkboxQuestionListener } from './checkboxQuestionListener';
import { dateQuestionListener } from './dateQuestionListener';
import { customFeildGoBackAnimationHandler } from './movePages';
import { numberQuestionListener } from './numberQuestionListener';
import { selectQuestionListener } from './selectQuestionListener';
import { textAreaQuestonListener } from './textareaQuestionListener';
import { textQuestionListener } from './textQuestionListener';
import { navigateToNextPage } from './navigationHelper';

export function heightQuestionListener() {
    // check has data
    if (
        listNamePageQuestion.find((name) => name === nameScreenDynamic) &&
        listDataQuestion[nameScreenDynamic.split('--')[1]]
    ) {
        let regex = /\d+/g;
        let data = listDataQuestion[nameScreenDynamic.split('--')[1]];
        var matches = data.match(regex);
        const valueFeet = document.querySelector(
            `${nameScreenDynamic} .height_feet`
        );
        const valueIn = document.querySelector(
            `${nameScreenDynamic} .height_inch`
        );
        if (valueFeet) {
            valueFeet.value = matches[0];
        }
        if (valueIn) {
            valueIn.value = matches[1];
        }
        setTimeout(() => {
            if (document.getElementById('height_feet')) {
                document.getElementById('height_feet').focus();
            }
        }, 500);
        document
            .querySelector(`${nameScreenDynamic} .heightQuestionContinue__btn`)
            ?.classList.remove('disabled');
        document
            .querySelector(`${nameScreenDynamic} .heightQuestion__valid`)
            ?.classList.remove('hidden');
        document
            .querySelector(
                `${nameScreenDynamic} .heightQuestionContinue__btn .loading__wrapper`
            )
            ?.classList.add('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<i class="ri-arrow-right-line"></i>`
            );
        }
        document
            .querySelector(`${nameScreenDynamic} .heightQuestion__invalid`)
            ?.classList.add('hidden');
        return;
    }

    validateHeight();

    const isValidIcon = document.querySelector(
        `${nameScreenDynamic} .heightQuestion__valid`
    );

    isValidIcon?.addEventListener('click', function () {
        document
            .querySelector(`${nameScreenDynamic} .heightQuestionContinue__btn`)
            ?.click();
    });

    /* On click enter */
    const screenHeightQuestion = document.querySelector(
        `${nameScreenDynamic} .screen--height`
    );

    if (screenHeightQuestion) {
        screenHeightQuestion.addEventListener('keydown', (event) => {
            if (
                event.key === 'Enter' &&
                !document
                    .querySelector(
                        `${nameScreenDynamic} .heightQuestionContinue__btn`
                    )
                    .classList.contains('disabled')
            ) {
                document
                    .querySelector(
                        `${nameScreenDynamic} .heightQuestionContinue__btn`
                    )
                    .click();
            }
        });
    }

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .heightQuestionBack__btn`)
        ?.addEventListener('click', () => {
            const idx = listNamePageQuestion.findIndex(
                (l) => l === nameScreenDynamic
            );
            if (idx > 0) {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion - 1,
                    progress:
                        ((progressQuestion.currentQuestion - 1) /
                            progressQuestion.total) *
                        100,
                });
                setNameScreenDynamic(listNamePageQuestion[idx - 1]);

                if (
                    nameScreenDynamic.includes('text') &&
                    !nameScreenDynamic.includes('textarea')
                ) {
                    textQuestionListener();
                } else if (nameScreenDynamic.includes('checkbox')) {
                    checkboxQuestionListener();
                } else if (nameScreenDynamic.includes('select')) {
                    selectQuestionListener();
                } else if (nameScreenDynamic.includes('date')) {
                    dateQuestionListener();
                } else if (nameScreenDynamic.includes('textarea')) {
                    textAreaQuestonListener();
                } else if (nameScreenDynamic.includes('number')) {
                    numberQuestionListener();
                } else if (nameScreenDynamic.includes('height')) {
                    heightQuestionListener();
                }
            } else {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
            }
        });

    /* on click Continue */
    document
        .querySelector(`${nameScreenDynamic} .heightQuestionContinue__btn`)
        ?.addEventListener('click', async () => {
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic)
            ) {
                listNamePageQuestion.push(nameScreenDynamic);
            }
            setListNamePageQuestion(listNamePageQuestion);
            document
                .querySelector(
                    `${nameScreenDynamic} .heightQuestionContinue__btn`
                )
                .classList.add('disabled');
            document
                .querySelector(
                    `${nameScreenDynamic} .heightQuestionContinue__btn .loading__wrapper`
                )
                ?.classList.remove('hidden');
            const loaderIcon = document.querySelector(
                `${nameScreenDynamic} .loader__icon`
            );
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML(
                    'beforeend',
                    `<img src="${appUrl}/assets/icons/rolling.png" />`
                );
            }
            const item = nameScreenDynamic.split('--')[1];
            const valFeet = document.getElementById('height_feet').value;
            const valIn = document.getElementById('height_inch').value;
            listDataQuestion[item] = `${valFeet} FT - ${valIn} IN`;
            setListDataQuestion(listDataQuestion);
            // find index
            const fields = questionnaireFields?.length
                ? questionnaireFields
                : form?.form?.custom_fields ?? [];
            const formId = questionnaireFormId ?? form?.form?.id;
            let idx = fields.findIndex(
                (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
            );
            if (idx == fields.length - 1) {
                try {
                    const fieldLabels = {};
                    const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                    sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || 'Custom field'); });
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                    } else {
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                    document
                        .querySelector(
                            `${nameScreenDynamic} .heightQuestion__container .heightQuestionContinue__btn`
                        )
                        ?.classList.remove('disabled');
                    document
                        .querySelector(
                            `${nameScreenDynamic} .heightQuestionContinue__btn .loading__wrapper`
                        )
                        ?.classList.add('hidden');
                    const valueFeet = document.querySelector(
                        `${nameScreenDynamic} .height_feet`
                    );
                    const valueIn = document.querySelector(
                        `${nameScreenDynamic} .height_inch`
                    );
                    if (valueFeet) {
                        valueFeet.value = '';
                    }
                    if (valueIn) {
                        valueIn.value = '';
                    }
                    const loaderIcon = document.querySelector(
                        `${nameScreenDynamic} .loader__icon`
                    );
                    if (loaderIcon) {
                        loaderIcon.innerHTML = '';
                        loaderIcon.insertAdjacentHTML(
                            'beforeend',
                            `<i class="ri-arrow-right-line"></i>`
                        );
                    }
                    document
                        .querySelector(
                            `${nameScreenDynamic} .heightQuestion__invalid`
                        )
                        ?.classList.add('hidden');
                    document
                        .querySelector(
                            `${nameScreenDynamic} .heightQuestion__valid`
                        )
                        ?.classList.add('hidden');
                    clearCustomFields();
                    clearQuestionnaireContext();
                    navigateToNextPage();
                } catch (error) {
                    toastError(error.response?.data?.message);
                }
            } else {
                // handle
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion + 1,
                    progress:
                        ((progressQuestion.currentQuestion + 1) /
                            progressQuestion.total) *
                        100,
                });
                loadCustomFields(fields[idx + 1]);
            }
        });
}

function validateHeight() {
    const heightQuestionEle = document.querySelector('.heightQuestion');
    const ftInput = heightQuestionEle.querySelector('#height_feet');
    ftInput?.addEventListener('keyup', function () {
        if (parseInt(ftInput.value) > 8 || parseInt(ftInput.value) < 3) {
            ftInput.classList.add('error');
            heightQuestionEle
                .querySelector('.heightQuestion__valid')
                .classList.add('hidden');
            heightQuestionEle
                .querySelector('.heightQuestion__invalid')
                .classList.remove('hidden');
        } else if (
            parseInt(ftInput.value) >= 3 &&
            parseInt(ftInput.value) <= 8
        ) {
            ftInput.classList.remove('error');
            heightQuestionEle
                .querySelector('.heightQuestion__valid')
                .classList.remove('hidden');
            heightQuestionEle
                .querySelector('.heightQuestion__invalid')
                .classList.add('hidden');
        }

        checkContinueForTypeHeight();
    });

    ftInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') document.getElementById('height_inch')?.focus();
    });

    const inInput = document.querySelector('#height_inch');
    inInput?.addEventListener('keyup', function () {
        if (parseInt(inInput.value) > 11 || parseInt(inInput.value) < 0) {
            inInput?.classList.add('error');
            heightQuestionEle
                .querySelector('.heightQuestion__valid')
                .classList.add('hidden');
            heightQuestionEle
                .querySelector('.heightQuestion__invalid')
                .classList.remove('hidden');
        } else if (
            parseInt(inInput.value) <= 11 &&
            parseInt(inInput.value) >= 0
        ) {
            inInput.classList.remove('error');
            heightQuestionEle
                .querySelector('.heightQuestion__valid')
                .classList.remove('hidden');
            heightQuestionEle
                .querySelector('.heightQuestion__invalid')
                .classList.add('hidden');
        }

        checkContinueForTypeHeight();
    });

    inInput.addEventListener('keydown', function (e) {
        if (
            e.key === 'Backspace' &&
            !document.getElementById('height_inch').value
        ) {
            e.preventDefault();
            document.getElementById('height_feet').focus();
        }
    });
}

function checkContinueForTypeHeight() {
    if (
        !document.querySelector('#height_feet')?.classList.contains('error') &&
        !document.querySelector('#height_inch')?.classList.contains('error') &&
        document.getElementById('height_inch')?.value &&
        document.getElementById('height_feet')?.value
    ) {
        document
            .querySelector(`${nameScreenDynamic} .heightQuestionContinue__btn`)
            ?.classList.remove('disabled');
    } else {
        document
            .querySelector(`${nameScreenDynamic} .heightQuestionContinue__btn`)
            ?.classList.add('disabled');
    }
}
